import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { AudioManager } from "../AudioManager";
import { GameManager } from "../GameManager";

export class PuzzleButton extends Phaser.Group {

    private key: string;

    constructor(game: Phaser.Game, level: number, key: string) {

        super(game, null, "puzzle-button");

        this.name = level.toString();
        this.key = key;

        const button = new Phaser.Button(this.game, 0, 0, "texture_atlas_1", this.onClick, this);

        switch (GameVars.puzzleMoves) {
            case 2:
                button.setFrames("btn_menu_2_moves_on.png", "btn_menu_2_moves_off.png", "btn_menu_2_moves_on.png",  "btn_menu_2_moves_off.png");
                break;
            case 3:
                button.setFrames("btn_menu_3_moves_on.png", "btn_menu_3_moves_off.png", "btn_menu_3_moves_on.png",  "btn_menu_3_moves_off.png");
                break;
            case 4:
                button.setFrames("btn_menu_4_moves_on.png", "btn_menu_4_moves_off.png", "btn_menu_4_moves_on.png",  "btn_menu_4_moves_off.png");
                break;

            default:
        }

        button.forceOut = true;
        button.anchor.set(.5);
        this.add(button);

        let textSize: number;
    
        if (level < 100) {
            textSize = 80;
        } else {
            textSize = 60;
        }

        const levelLabel = new Phaser.BitmapText(this.game, -8, -4, "roboto-slab", level.toString(), textSize); 
        levelLabel.anchor.set(.5);
        this.add(levelLabel);

        let levelPassed = false;
        let levelPlayed = false;

        if (GameVars.gameData.solvedProblems[key] === GameConstants.SOLVED) {
            levelPassed = true;
        } else if (GameVars.gameData.solvedProblems[key] === GameConstants.PLAYED) {
            levelPlayed = true;
        }

        if (levelPassed) {

            const checkbox = new Phaser.Image(this.game, 42, -64, "texture_atlas_1", "checkbox.png");
            checkbox.anchor.set(.5);
            this.add(checkbox);

            if (this.key !== GameVars.currentLevel || !GameVars.showLevelCompleted) {
                const checkedSign = new Phaser.Image(this.game, 42, -64, "texture_atlas_1", "checked_level.png");
                checkedSign.anchor.set(.5);
                this.add(checkedSign);
            }
        } else if (levelPlayed) {
            
            const checkbox = new Phaser.Image(this.game, 42, -64, "texture_atlas_1", "checkbox.png");
            checkbox.anchor.set(.5);
            this.add(checkbox);
        }

        if (GameVars.showLevelCompleted && this.key === GameVars.currentLevel) {

            const checkedSign = new Phaser.Image(this.game, 42, -64, "texture_atlas_1", "checked_level.png");
            checkedSign.scale.set(0);
            checkedSign.anchor.set(.5);
            this.add(checkedSign);

            let tween = this.game.add.tween(checkedSign.scale)
                .to({x: 1, y: 1}, 750, Phaser.Easing.Elastic.Out, true, 500);

            tween.onStart.add(function(): void {
                AudioManager.playSound("checked_puzzle");
            },this);

            tween.onComplete.add(function(): void {
                GameVars.showLevelCompleted = false;
            }, this);
            
        } else if (this.key === GameVars.gameData.lastProblems[GameVars.puzzleMoves - 2] && !levelPassed) {
            this.game.add.tween(this.scale)
                .to({x: 1.1, y: 1.1}, 750, Phaser.Easing.Linear.None, true, 0, -1, true);
        }
    }

    private onClick(b: Phaser.Button, p: Phaser.Pointer): void {

        if (GameVars.showLevelCompleted) {
            return;
        }

        let delta = Math.sqrt((p.positionDown.x - p.position.x) * (p.positionDown.x - p.position.x) + (p.positionDown.y - p.position.y) * (p.positionDown.y - p.position.y));
        
        if (delta < 100) {

            AudioManager.playSound("click"); 
            GameManager.oncPuzzleChosen(this.name, this.key);
        }
    }
}
